const KEY = "mhm-consent";
const VID = "mhm-vid";

export const getConsent = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
};

export const setConsent = (c) => {
  const v = { analytics: !!c.analytics, marketing: !!c.marketing, at: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(v));
  if (!v.analytics) localStorage.removeItem(VID);
  window.dispatchEvent(new CustomEvent("mhm-consent", { detail: v }));
};

const rid = () => (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

export const visitorInfo = () => {
  if (!getConsent()?.analytics) return null;
  let vid = localStorage.getItem(VID);
  const returning = !!vid;
  if (!vid) {
    vid = rid();
    localStorage.setItem(VID, vid);
  }
  let sid = sessionStorage.getItem("mhm-sid");
  if (!sid) {
    sid = rid();
    sessionStorage.setItem("mhm-sid", sid);
    sessionStorage.setItem("mhm-returning", returning ? "1" : "0");
  }
  return { visitor_id: vid, session_id: sid, returning: sessionStorage.getItem("mhm-returning") === "1" };
};

export const newEventId = rid;
